var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRawdh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.847+458.25L455.405+438.172L457.309+407.189L474.964+391.265",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.979+434.537L437.751+456.173L419.576+414.978L456.271+437.479L421.654+385.38L458.694+405.977L437.578+369.456L474.445+392.823",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.46+435.748L418.019+415.67L419.923+384.688L437.578+368.764",
    stroke: "#000000",
    strokeWidth: 4.39629,
    fill: "none",
    opacity: 1,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.773+41.1557C25.773+41.1557+25.4545+51.4184+25.8853+52.2171C26.656+53.6458+28.5923+54.6421+32.07+54.6045C35.0401+54.5724+37.9728+53.1006+37.9728+51.4463C37.9728+49.792+37.8323+41.1364+37.8323+41.1364C37.8323+41.1364+34.7019+42.8929+31.9009+42.8177C29.0999+42.7425+25.773+41.1557+25.773+41.1557Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7458+36.2567C25.7458+36.2567+25.6563+37.7844+25.9048+38.3592C26.2675+39.1978+27.8886+40.741+32.0929+40.8234C35.508+40.8903+37.9678+38.7942+37.9946+37.9373C38.048+36.2284+38.0481+36.3974+38.0481+36.3974C38.0481+36.3974+35.163+38.5182+31.9297+38.4652C28.3238+38.4061+25.7458+36.2567+25.7458+36.2567Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7157+20.24C25.7157+20.24+25.4776+33.5624+25.9084+34.361C26.6791+35.7897+28.6154+36.786+32.0932+36.7484C35.0632+36.7163+37.9959+35.2445+37.9959+33.5902C37.9959+31.9359+38.0044+20.0323+38.0044+20.0323C38.0044+20.0323+35.0245+22.0287+32.2235+21.9535C29.4225+21.8783+25.7157+20.24+25.7157+20.24Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4014+17.0204C25.4014+18.9981+28.2804+20.6013+31.8317+20.6013C35.3831+20.6013+38.2621+18.9981+38.2621+17.0204C38.2621+15.0427+35.3831+13.4394+31.8317+13.4394C28.2804+13.4394+25.4014+15.0427+25.4014+17.0204Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86259+2.41094L9.81304+2.34368L9.79677+61.4088L55.8441+61.365L55.7513+12.9487L57.743+13.4742L57.5137+63.0539L7.97045+63.0612",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9878+2.3491L7.88113+0.455633L45.5251+0.439428L57.7496+13.5483L43.976+13.33L43.976+1.71189L45.8571+1.90553L45.9175+11.6119L53.7547+11.7896L44.8344+2.25794",
    opacity: 1,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawdh);
export default __webpack_public_path__ + "static/media/rawdh.7342321bafad60d122f05659f3cb3c61.svg";
export { ForwardRef as ReactComponent };